import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { calcRem, getComponentTheme } from '../../__styling'
import {
    IconCheckmarkTN,
    IconEmailTN,
    IconFacebook,
    IconLink,
    IconLinkedInTN,
} from '../../icons'

export const StyledSharing = styled.div(({ theme }) => {
    const sharingTheme = getComponentTheme(theme, 'sharing')

    return {
        display: 'flex',
        gap: sharingTheme.gap,
        flexWrap: 'wrap',
    }
})

export const StyledButton = styled.button(({ theme }) => {
    const buttonTheme = getComponentTheme(theme, 'sharing').button

    return {
        width: calcRem(40),
        height: calcRem(40),
        borderRadius: '50%',
        border: 'none',
        margin: 0,
        padding: 0,
        backgroundColor: buttonTheme.backgroundColor,
        cursor: 'pointer',

        ['&:is(:hover, :focus)']: {
            backgroundColor: buttonTheme.hover.backgroundColor,
            outline: 'none',
        },
        transition: 'background 0.2s',
    }
})

const disappear = keyframes`
    0% {
        opacity: 1;
    }
    20% {
        opacity: 0;
    }
`
const appear = keyframes`
    0% {
        opacity: 0;
    }
    80% {
        opacity: 1;
    }
`
export const StyledButtonText = styled.span(({ theme }) => {
    const buttonTheme = getComponentTheme(theme, 'sharing').button

    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: buttonTheme.color,
        fontSize: calcRem(16),
        fontWeight: 400,
        lineHeight: '150%',
        overflow: 'hidden',

        span: {
            display: 'flex',
            alignItems: 'center',
            minWidth: calcRem(121),
            justifyContent: 'center',
            gap: buttonTheme.gap,
            transition: '0.5s all ease-in-out',
        },
        '&.copied': {
            span: {
                ':first-child': {
                    opacity: 0,
                    animation: `${disappear} 0.5s ease`,
                    display: 'none',
                },
                ':last-child': {
                    opacity: 1,
                    animation: `${appear} 0.5s ease`,
                    display: 'flex',
                },
            },
        },

        '&.default': {
            span: {
                ':first-child': {
                    opacity: 1,
                    animation: `${appear} 0.5s ease`,
                    display: 'flex',
                },
                ':last-child': {
                    opacity: 0,
                    display: 'none',
                    animation: `${disappear} 0.5s ease`,
                },
            },
        },
    }
})

export const StyledClipboardButton = styled.button(({ theme }) => {
    const buttonTheme = getComponentTheme(theme, 'sharing').button

    return {
        backgroundColor: buttonTheme.backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: calcRem(40),
        border: 'none',
        margin: 0,
        padding: calcRem(8, 16),
        textTransform: 'uppercase',
        cursor: 'pointer',

        ['&:is(:hover, :focus)']: {
            backgroundColor: buttonTheme.hover.backgroundColor,
            outline: 'none',
        },
        transition: 'background 0.2s',
    }
})

export const StyledLinkIcon = styled(IconLink)(({ theme }) => {
    const iconTheme = getComponentTheme(theme, 'sharing').icon

    return {
        width: calcRem(22),
        height: calcRem(22),
        fill: iconTheme.fill,
    }
})
export const StyledLinkedInIcon = styled(IconLinkedInTN)(({ theme }) => {
    const iconTheme = getComponentTheme(theme, 'sharing').icon

    return {
        width: calcRem(22),
        height: calcRem(22),
        fill: iconTheme.fill,
        path: {
            fill: iconTheme.fill,
        },
    }
})
export const StyledFacebookIcon = styled(IconFacebook)({
    width: calcRem(22),
    height: calcRem(22),
})
export const StyledEmailIcon = styled(IconEmailTN)({
    width: calcRem(24),
    height: calcRem(24),
    fill: 'none',
})
export const StyledCheckmarkIcon = styled(IconCheckmarkTN)({
    width: calcRem(24),
    height: calcRem(24),
})
